<template>
  <div>
    <Header :title="title" :goBackHandler="goBack"></Header>
    <div id="header" class="store-header">
      <div class="profile">
        <img class="avatar" :src="$store.state.personInfo.avatar" />
        <div class="name-wrap">
          <div class="name">{{$store.state.personInfo.nickname}}</div>
          <div class="integral">{{point_name}}：{{integral.current}}</div>
        </div>
        <router-link class="record" :to="{name:'IntegralRecord'}">兑换记录</router-link>
      </div>
    </div>
    <div :class="{'fixed':fixed}" class="fixed-wrap">
      <div class="search" @click="$router.push({name:'IntegralStoreSearch'})">
        <span>搜索</span>
        <img src="@/assets/images/search-gray@2x.png" />
      </div>
      <div class="tabs">
        <div class="tab-header">
          <div
            class="tab-header-item"
            :class="{'tab-header-item-active':tab==1}"
            @click="changeTab(1)"
          >好课推荐</div>
          <div
            class="tab-header-item"
            :class="{'tab-header-item-active':tab==2}"
            @click="changeTab(2)"
          >热门图书</div>
        </div>
      </div>
    </div>
    <List
      ref="list"
      :class="{'fixed':fixed}"
      class="list"
      url="/api/integral/shop/index"
      :params="{type:tab}"
      :on-getdata="onGetdata"
      method="get"
    >
      <template slot="item">
        <template v-for="(item, index) in list">
          <IntegralItem :key="index" :item="item"></IntegralItem>
        </template>
      </template>
    </List>
  </div>
</template>
<script>
import Header from "@/components/Header";
import List from "@/components/List";
import IntegralItem from "@/components/integral/IntegralItem";
export default {
  name: "IntegralStore",
  components: {
    Header,
    List,
    IntegralItem
  },
  data() {
    return {
      title: {
        name: "积分商城"
      },
      tab: this.$route.query.tab || 1,
      fixed: false,
      list: [],
      integral: {}
    };
  },
  computed: {
    point_name() {
      if(this.$store.state.config){
        return this.$store.state.config.point_info.point_name
      } else{
        return '';
      };
    }
  },
  async created() {
    let data = await this.$http.get("/api/app/user/integral");
    this.integral = data;
    document.title = this.point_name + "商城";
  },
  watch: {
    point_name(val) {
      document.title = val + "商城";
    }
  },
  mounted() {
    this.$nextTick(() => {
      let $ = window.$;
      let $header = $("#header");
      $(window)
        .scrollTop(0)
        .scroll(() => {
          this.setFixed($header);
        })
        .resize(() => {
          this.setFixed($header);
        });
    });
  },
  methods: {
    goBack () {
      if (this.$store.state.app) {
        this.$pub.appAction("closeAppPage");
      } else{
        this.$router.go(-1);
      }
    },
    onGetdata(data) {
      this.list = data;
    },
    changeTab(tab) {
      this.tab = tab;
      this.$refs.list.goToFirst();
    },
    setFixed($header) {
      let $ = window.$;
      let height =
        $header.outerHeight() - parseInt((34 * $(window).width()) / 750);
      let scrollTop = $(window).scrollTop();
      if (scrollTop > height) {
        this.fixed = true;
      } else {
        this.fixed = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.store-header {
  position: relative;
  background-image: url("~@/assets/images/integral/store-header@3x.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;

  /deep/ {
    .header {
      background: transparent;
    }
    header {
      background: transparent;
      position: static;
      h3 {
        color: white;
      }
    }
  }
  .profile {
    padding: 70px 40px 94px 40px;
    display: flex;
    align-items: center;
    .avatar {
      width: 88px;
      height: 88px;
      border-radius: 50%;
      margin-right: 16px;
    }
    .name-wrap {
      flex-grow: 1;
    }
    .name {
      height: 50px;
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 50px;
      margin-bottom: 12px;
    }
    .integral {
      height: 34px;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 34px;
    }
    .record {
      width: 148px;
      height: 50px;
      border-radius: 26px;
      border: 1px solid rgba(255, 255, 255, 1);
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 50px;
      text-align: center;
    }
  }
}
.fixed-wrap {
  position: relative;
  padding-top: 84px;
  margin-bottom: 42px;
  &.fixed {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: white;
    box-shadow: 2px 2px 6px 0 rgba(0, 0, 0, 0.2);
    padding-top: 158px;
    z-index: 9;
    .search {
      top: 40px;
      box-shadow: none;
      background: rgba(246, 246, 246, 1);
      border-radius: 34px;
    }
  }
}
.search {
  position: absolute;
  width: 610px;
  height: 68px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 8px 12px 0px rgba(0, 0, 0, 0.06);
  border-radius: 34px;
  top: -34px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  padding: 0 24px;
  span {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(183, 183, 183, 1);
    flex-grow: 1;
  }
  img {
    width: 24px;
    height: 24px;
  }
}
.tabs {
  .tab-header {
    display: flex;
  }
  .tab-header-item {
    flex-grow: 1;
    text-align: center;
    height: 40px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(54, 56, 55, 1);
    line-height: 40px;
    position: relative;
  }
  .tab-header-item-active {
    color: $theme_color;
    &::after {
      content: "";
      width: 22px;
      height: 6px;
      background: $theme_color;
      border-radius: 4px;
      position: absolute;
      bottom: -6px;
      left: 50%;
      margin-left: -11px;
    }
  }
}
.list {
  padding: 0 30px;
  &.fixed {
    padding-top: 166px;
  }
}
</style>
